import { Avatar, Box, Typography } from "@mui/material";

const MessageHeader = ({
  fromClient,
  messageSentTime,
  userData,
}: {
  fromClient: boolean;
  messageSentTime: number;
  userData: any;
}) => {
  return (
    <div className="message__header">
      {fromClient ? (
        <>
          <Box className="message__header--right">
            {new Date(messageSentTime).toLocaleDateString()}{" "}
            {new Date(messageSentTime).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Box>
          <Box className="message__header--left">
            <Typography fontWeight="bold">{userData?.displayName}</Typography>
            <Avatar sx={{ width: 25, height: 25 }} src={userData?.profImage} />
          </Box>
        </>
      ) : (
        <>
          <Box className="message__header--left">
            <Avatar
              sx={{ width: 25, height: 25 }}
              src="/assets/avatarImage.png"
            />
            <Typography fontWeight="bold">DroneCakes</Typography>
          </Box>
          <Box className="message__header--right">
            {new Date(messageSentTime).toLocaleDateString()}{" "}
            {new Date(messageSentTime).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Box>
        </>
      )}
    </div>
  );
};

export default MessageHeader;
